/* eslint-disable no-undef */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { saveGeometry } from 'actions/spectrumActions';
import { createResource, editResource, getResourceDisplayValue, getResourceFormatChain } from 'actions/resourceActions';
import { getFormData, actionError } from 'helpers/actionHelpers';
import ResourceEdit from 'field/edit/ResourceEdit';
import API from 'constants/api';

const ResourceWithGeometryEdit = (props) => {
  const { field, createResource, editResource } = props;
  const objectUri = useSelector(state => state.object.uri);
  const view = useSelector(state => {
    if(state.object.view) {
      return state.object.view;
    }
    return state.view.view.props.view;
  });
  const resources = useSelector(state => state.modal.resources);
  const resourceFormatChain = getResourceFormatChain(resources, field.predicate);

  const createWithGeometry = () => {
    createResource({
      predicate: field.predicate,
      onSave: resource => {
        const formData = getFormData(resource);
        const headers = {
          method: 'POST',
          body: formData
        };
        if (resource.uri) {
          formData.set('objectUri', resource.uri);
        }
        formData.set('predicateUri', field.predicate);
        formData.set('parentUri', resource.parentUri);
        formData.set('classUri', resource.classUri);

        fetch(API.DAM.EDIT_RESOURCE, headers)
          .then(res => res.json())
          .then(res => {
            if (res.isCreated) {
              saveGeometry(resource.originalFields, res.uri)
                .then(() => getResourceDisplayValue(res.uri, field.predicate, '', objectUri, view, resourceFormatChain))
                .then(value => field.addValue(value));
            }
          });
      }
    });
  };

  const editWithGeometry = (index, value) => {
    editResource({
      predicate: field.predicate,
      index,
      value,
      onSave: resource => {
        const formData = getFormData(resource);
        const headers = {
          method: 'POST',
          body: formData
        };
        if (resource.uri) {
          formData.set('objectUri', resource.uri);
        }
        formData.set('predicateUri', field.predicate);
        formData.set('parentUri', resource.parentUri);
        formData.set('classUri', resource.classUri);

        fetch(API.DAM.EDIT_RESOURCE, headers)
          .then(res => res.json())
          .then(res => {
            if (!res.isCreated) {
              saveGeometry(resource.originalFields, res.uri)
                .then(() => getResourceDisplayValue(res.uri, field.predicate, '', objectUri, view, resourceFormatChain))
                .then(value => field.setValue(index, value));
            }
          });
      }
    });
  };

  return <ResourceEdit {...{
    ...props,
    onCreate: createWithGeometry,
    onEdit: editWithGeometry
  }} />;
};

export default connect(null, { createResource, editResource })(ResourceWithGeometryEdit);